import { ReactElement } from 'react';
import { MapInfoContainer } from '../../styles';
import {
  buildInfoProps,
} from '~/pages/NewOverview/helpers/map';
import { InfoCard } from '../InfoCard';
import { HealthUnitsInfo } from 'pages/NewOverview/contexts/HealthDataContext';
import { StateHint } from '../StateHint';
import { UnitHint } from '../UnitHint';
import { ThermalComfortUnitsInfo } from 'pages/NewOverview/contexts/ThermalComfortDataContext';

export type MapInfoProps =
  | {
      type: 'health';
      unitsMap: Map<string, HealthUnitsInfo>;
      scope: 'state' | 'unit';
      selected: boolean;
      onCloseInfoCard: () => void;
      name?: string;
      unitInfo?: { id: number; city: string };
      state?: string;
    }
  | {
      type: 'thermalComfort';
      unitsMap: Map<string, ThermalComfortUnitsInfo>;
      scope: 'state' | 'unit';
      selected: boolean;
      onCloseInfoCard: () => void;
      name?: string;
      unitInfo?: { id: number; city: string };
      state?: string;
    };

export function MapInfo(props: Readonly<MapInfoProps>): ReactElement {
  const {
    scope, name, selected, onCloseInfoCard, unitInfo,
  } = props;

  const infoProps = buildInfoProps(props);

  const showStateHint = scope === 'state' && !name;
  const showUnitHint = scope === 'state' && selected;

  return (
    <MapInfoContainer>
      {showStateHint ? (<StateHint />) : (
        <>
          <InfoCard
            name={name ?? ''}
            onClose={onCloseInfoCard}
            scope={scope}
            {...infoProps}
            unitInfo={unitInfo}
          />
          {showUnitHint && (
            <UnitHint />
          )}
        </>
      )}
    </MapInfoContainer>
  );
}
